import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import MoneyOutlinedIcon from '@mui/icons-material/MoneyOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';
import { Tabs } from '@mui/material';

const {RangePicker} = DatePicker;

export default function Statement() {

  const [page,setPage] = useState(1);
  const [statements,setStatements] = useState([]);
  const [totalStatements, setTotalStatements] = useState();
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [searchName,setSearchName] = useState('');
  const [trnxType, setTrnxType] = useState("all");
  const [reports,setReports] = useState({})
  const [date,setDate] = useState({startDate: "",endDate: ""})
  const didMount = useRef(false);

  const trnxTypeOptions = ['all', 'deposit', 'withdraw']

  const navigate = useNavigate()


   useEffect(()=>{
    const today = moment();
    const startDate = moment(today).subtract(30, 'days').format('YYYY-MM-DD');
    const endDate = moment(today).format('YYYY-MM-DD');
    setDate({startDate: startDate,endDate: endDate})
   },[])

  async function fetchData() {
    // if(!searchName){
    //   setErrorMsg({ info: true, msg: "Need to input username!" })
    //   setOpenAlert(true)
    //   setLoading(false)
    //   return
    // }
    setLoading(true)
    let data = await axios.get(`/report/getStatementByMaster?type=${trnxType}&holderName=${searchName}&startDate=${date.startDate} 00:00:00&endDate=${date.endDate} 23:59:59&current=${page}&pageSize=10`)

    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setStatements([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setStatements(data.data.transactions);
    setReports(data?.data?.report);
    setTotalStatements(data.data.pagination.total);
    setLoading(false);
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)

  const handleTrnxTypeChange = (value) => setTrnxType(value);
  
  const handleSearchUsername = ({currentTarget}) => setSearchName(currentTarget.value);
  
  const handleDateChange = async (v,dateString) => setDate({startDate: dateString[0],endDate: dateString[1]});
  
  useEffect(()=> {
    if(didMount.current){
      fetchData()
    }else{
      didMount.current = true;
    }
  },[trnxType,searchName,date,page])

  const columns = [
      {
        title: 'Username',
        dataIndex: 'holder_name',
        key: 'holder_name',
      },
      {
        title: 'Trnx Type',
        dataIndex: 'trnx_type',
        key: 'trnx_type',
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
      },
      {
        title: 'Date',
        key: 'trnx_date',
        dataIndex: 'trnx_date',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      },
      {
        title: 'Reason',
        key: 'reason',
        dataIndex: 'reason',
      },
      {
        title: 'Amount',
        key: 'adjustment',
        dataIndex: 'adjustment',
      },
      {
        title: 'Opening Balance',
        key: 'before',
        dataIndex: 'before',
      },
      {
        title: 'Closing Balance',
        key: 'after',
        dataIndex: 'after',
      },
  ];

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div  style={{display: 'flex', overflowX: "scroll",overflow: 'hidden'}}>
        <Tabs
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
          >
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <MoneyOutlinedIcon    style={{fontSize: "2.5rem",marginRight: "1rem",color: "#399bac"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Deposit Amount</h3>
               <h3 style={{fontWeight: "normal",color: "#000dff"}}>{reports?.totalDeposit != 0 && "+" }{Number(reports?.totalDeposit || 0).toLocaleString()}</h3>
             </div>
          </div>
          <div style={{display: 'flex',alignItems: "center",padding: "0 3rem 2rem 1rem"}}>
            <CurrencyExchangeOutlinedIcon   style={{fontSize: "2.5rem",marginRight: "1rem",color: "#cc4a3f"}}/>
             <div>
               <h3 style={{marginBottom: "1rem",fontWeight: "normal"}}>Total Withdraw Amount</h3>
               <h3 style={{fontWeight: "normal",color: "red"}}>{reports?.totalWithdraw != 0 && "-" }{Number(reports?.totalWithdraw || 0).toLocaleString()}</h3>
             </div>
          </div>
          <div>
          </div>
        </Tabs>
       </div>
       <div style={{display: 'flex'}}>
         <Space direction="vertical" size={12}>
          <RangePicker
            value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
            onChange={(v,dateString)=> handleDateChange(v,dateString)}/>
          </Space>
          <Select
            defaultValue='all'
            style={{width: "20%",marginLeft: "2rem"}}
            onChange={handleTrnxTypeChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={trnxTypeOptions.map((c)=> ({value: c,label: c}))}
            placeholder="Select Category"
          />
          <Input placeholder="Username..."  style={{width: "20%",marginLeft: "2rem"}} onChange={handleSearchUsername}/>
       </div>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={statements} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalStatements} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}
